import React from 'react';

import logo from '../../s3Logo.svg';

export default () => {
	return (
		<img src={logo} alt="Logo" style= {{width: '50px', margin: '10px'}}/>
	);
};